module.exports = "/_next/static/images/ovo-17fffbbae651e7d46f7bcd3625197d1a.png";